export enum EmployeeSelectionSource {
    Dropdown,
    Confirm,
}
